var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 100,
    viewBox: "0 0 113 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_1748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.841 31.9396H77.6462C75.7767 31.9396 73.9838 32.6822 72.6619 34.0041C71.34 35.326 70.5974 37.1189 70.5974 38.9883V91.8538C70.5974 93.7233 71.34 95.5161 72.6619 96.838C73.9838 98.1599 75.7767 98.9025 77.6462 98.9025H105.841C107.711 98.9025 109.503 98.1599 110.825 96.838C112.147 95.5161 112.89 93.7233 112.89 91.8538V38.9883C112.89 37.1189 112.147 35.326 110.825 34.0041C109.503 32.6822 107.711 31.9396 105.841 31.9396ZM105.841 38.9883V84.8051H77.6462V38.9883H105.841Z",
    fill: "#235379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7437 0.220337H7.15885C5.2894 0.220337 3.49653 0.96297 2.17463 2.28486C0.85274 3.60676 0.110107 5.39963 0.110107 7.26908V63.659C0.110107 65.5284 0.85274 67.3213 2.17463 68.6432C3.49653 69.9651 5.2894 70.7077 7.15885 70.7077H35.3538V77.7565H25.9085C24.8288 77.6338 23.7432 77.9314 22.877 78.5876C22.0108 79.2438 21.4305 80.2082 21.2563 81.2808C21.4305 82.3535 22.0108 83.3179 22.877 83.9741C23.7432 84.6303 24.8288 84.9279 25.9085 84.8052H63.2668V83.5012H63.5487V63.659H7.15885V7.26908H91.7437V24.8909H98.7924V7.26908C98.7924 5.39963 98.0498 3.60676 96.7279 2.28486C95.406 0.96297 93.6131 0.220337 91.7437 0.220337Z",
    fill: "#235379"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_1748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 99.1228,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.5cfd78abcb141b1155706f8cf74a4091.svg";
export { ForwardRef as ReactComponent };